import request from '@/utils/request'
import axios from 'axios'

export function quAdd(data) {
  return request({
    url: '/course-questions',
    method: 'post',
    data
  })
}

export function quPaging(params) {
  // 如果有 repoId，使用按题库分页接口
  if (params && params.repoId) {
    const { repoId, pageNum, pageSize, content, year, difficulty } = params
    return request({
      url: `/course-questions/repo/${repoId}/paging`,
      method: 'get',
      params: { pageNum, pageSize, content, year, difficulty }
    })
  }
  // 否则使用全局分页接口（总题库查询）
  return request({
    url: '/course-questions/global/paging',
    method: 'get',
    params
  })
}

export function quUpdate(id, data) {
  return request({
    url: `/amc-questions/${id}`,
    method: 'put',
    data
  })
}

export function quDel(id) {
  return request({
    url: `/amc-questions/${id}`,
    method: 'delete'
  })
}

export function quBatchDel(ids) {
  return request({
    url: '/amc-questions/batch',
    method: 'delete',
    data: { ids }
  })
}

export function quDetail(id) {
  return request({
    url: `/amc-questions/single/${id}`,
    method: 'get'
  })
}

export function quDetailbyKnowledge(knowledge) {
  return request({
    url: `/amc-questions/single/${knowledge}`,
    method: 'get'
  })
}

export function quDetailbyContent(content) {
  return request({
    url: '/amc-questions/byContent',
    method: 'get',
    params: { content }
  })
}

export function importQue(repoId, formData) {
  return request({
    url: `/amc-questions/import/${repoId}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// export function importOcrQu(id, data) {
//   return request({
//     url: `questions/ocr/import/${id}`,
//     method: 'post',
//     data
//   })
// }

export function saveOcrQuestions(data) {
  return request({
    url: '/amc-questions/saveQuestions',
    method: 'post',
    data
  })
}

/**
 * 根据题库id查找题目
 * @param repoId 题库id
 * @returns 题目列表
 */
export function getQuestionsByRepoId(repoId) {
  return request({
    url: `/amc-questions/byRepoId/${repoId}`,
    method: 'get'
  })
}

export function getOneUnattemptedQuestion(userId, repoId) {
  return request({
    url: '/amc-questions/one-unattempted',
    method: 'get',
    params: { userId, repoId }
  })
}

export function getQuestionNumByRepoId(repoId) {
  return request({
    url: `/amc-questions/count/${repoId}`,
    method: 'get'
  })
}

/// 获取用户做题进度、正确率、做题数量
export function getProgressByRepoId(repoId) {
  return request({
    url: `/amc-questions/progress/${repoId}`,
    method: 'get'
  })
}

export function getQuestionsByKnowledge(knowledge) {
  return request({
    url: '/amc-questions/byKnowledge',
    method: 'get',
    params: { knowledge }
  })
}

// 获取历年真题年份列表
export function listYears(repoId) {
  return request({
    url: '/amc-questions/years',
    method: 'get',
    params: repoId != null ? { repoId } : {}
  })
}

// 按年份查询题目
export function getQuestionsByYear(year, repoId) {
  return request({
    url: '/amc-questions/byYear',
    method: 'get',
    params: Object.assign({ year }, repoId != null ? { repoId } : {})
  })
}

// 按难度查询题目：level 可为 '简单' / '中等' / '困难' / 'easy' / 'medium' / 'hard'
export function getByDifficulty(level, repoId) {
  const params = Object.assign({ level }, repoId != null ? { repoId } : {})
  return request({
    url: '/amc-questions/byDifficulty',
    method: 'get',
    params
  })
}

// 根据题目知识点在同题库推荐相似题
export function findSimilar(id, limit) {
  const params = {}
  if (limit != null && limit !== '') params.limit = limit
  return request({
    url: `/amc-questions/similar/${id}`,
    method: 'get',
    params
  })
}

/**
 * 无尽模式推题接口（AMC双语题目）
 * 优先推荐未做过的题目，其次推荐做错的题目
 * @param {Object} data - 请求参数
 * @param {number} data.userId - 用户ID
 * @param {number} data.repoId - 题库ID
 * @param {number[]} data.excludeIds - 需要排除的题目ID列表
 * @param {number} data.count - 请求题目数量，默认5
 * @returns 推荐的AMC双语题目列表
 */
export function recommendEndlessQuestions(data) {
  return request({
    url: '/amc-questions/endless/recommend',
    method: 'post',
    data
  })
}
